<div class="ui inverted vertical center aligned segment">

    <div class="ui stackable grid text-center">
        <div class="two wide column">
        </div>
        <div class="three wide column">
            <h2 class="title">Voyages Schiltz</h2>
        </div>
        <div class="one wide column">
            <div class="separator"></div>
        </div>
        <div class="four wide column header-container">
            <p class="description">Autobus, autocars et minibus.</p>
        </div>
        <div class="four wide column">
            <button (click)="discoverClicked()" class="ui button button-header">Découvrez nos services</button>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/trips/header/header.html